import type { FC, ReactNode } from 'react'
import type { ContentBlock, FaqItem } from '@/types/content'

import { cn } from '@/lib/utils'
import { ButtonLink } from '@/components/generals/button-link'
import { Container } from '@/components/generals/container'
import { SectionIntro } from '@/components/generals/section-intro'
import { FaqList } from '@/components/sections/faq-list'
import { cms, hasValue } from '@/lib/cms'
import { reveal } from '@/lib/reveal'

interface FaqSectionProps {
    block?: ContentBlock
    items: Array<FaqItem>
    id?: string
    className?: string
}

// Section 09: the most frequent questions, intro on the left, accordion on the right.
export const FaqSection: FC<FaqSectionProps> = ({ block, items, id = 'faq', className }): ReactNode => {
    if (items.length === 0) return null

    const headingId = `${id}-titel`

    return (
        <section id={id} aria-labelledby={headingId} className={cn('relative bg-paper py-24 sm:py-32 lg:py-40', className)}>
            <Container className='grid gap-14 lg:grid-cols-12 lg:gap-10'>
                <div className='lg:col-span-5'>
                    <div className='flex flex-col gap-10 lg:sticky lg:top-[calc(var(--header-height)+2rem)]'>
                        <SectionIntro block={block} headingId={headingId} size='lg' />

                        {block && hasValue(block.button_text) && hasValue(block.button_link) && (
                            <div {...reveal(200)}>
                                <ButtonLink
                                    href={block.button_link}
                                    label={block.button_text}
                                    labelCms={cms('inhalte', block.id, 'button_text')}
                                    variant='secondary'
                                />
                            </div>
                        )}
                    </div>
                </div>

                <div className='lg:col-span-7' {...reveal(120)}>
                    <FaqList items={items} />
                </div>
            </Container>
        </section>
    )
}
